import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/earnings-benchmarks-dashboard',
    name: 'EarningsBenchmarksDashboard',
    component: () => import('@/views/EarningsBenchmarksDashboard.vue'),
    meta: {
      layout: 'LayoutAuthenticated',
      requiresAuth: true,
      title: 'pageEarningsBenchmarksDashboard.metaTitle',
    },
  },
];
export default routes;
